import {CopyPasteConnectorData} from 'src/app/shared/models/copy-paste-connector-data.interface';
import {UserInBuffer} from 'src/app/shared/models/user-in-buffer.interface';
import {ConnectorLink} from 'src/app/shared/utils/connector-link';

export class CopyPasteBuffer implements CopyPasteConnectorData {
  public user: UserInBuffer;
  public link: ConnectorLink;

  constructor(data?: CopyPasteConnectorData) {
    this.user = data?.user ?? {};
    this.link = data?.link ?? new ConnectorLink();
  }

  public hasLink(): boolean {
    return Boolean(this.link?.connector.id);
  }

  public toString(): string {
    const data = {
      user: this.user,
      link: this.link
    };

    return JSON.stringify(data);
  }
}
